
























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
  List,
  Checkbox,
  CheckboxGroup,
  Button,
  Lazyload,
  Dialog,
  Toast,
} from 'vant';
import { namespace, State, Action } from 'vuex-class';

import SearchInput from './SearchInput.vue';
import TipDownloadSy from '@/components/TipDownloadSy.vue';
import VoteButton from '@/components/VoteButton.vue';

import { getlist, searchData, userInfo, baseInfo } from '../api/index';
import { getLocalTime, nowInDateBetwen } from '../util/index';
import { STOR_NAME } from '../api/index';
import LikeButton from './LikeButton.vue';
import EventBus from '../bus';

Vue.use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Lazyload)
  .use(Dialog)
  .use(Button)
  .use(Toast);
const Modules = namespace(STOR_NAME);

@Component({
  components: {
    SearchInput,
    VoteButton,
    TipDownloadSy,
    LikeButton,
  },
})
export default class VoteList extends Vue {
  @Modules.State('userInfo') userInfoData!: any;
  @Modules.Action fetchUserInfo!: () => void;

  @Prop() listType!: any;
  @Prop() options!: any;

  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];
  result = [];
  SearchData = '';
  startTime = '';
  endTime = '';
  clearInputValue: any = '';

  created() {
    this.listenDetail();

    window.userInfoChange = () => {
      this.$router.go(0);
      this.fetchUserInfo();
      this.testUserInfoChange();
    };

    baseInfo().then((res: any) => {
      this.startTime = getLocalTime(res.data.startTime);
      this.endTime = getLocalTime(res.data.endTime);
      this.$addPv(res.data.activityId);
    });
  }

  async testUserInfoChange() {
    const res = await userInfo();
    console.log(res);
  }

  // 初使加载
  async onLoad() {
    this.loading = true;

    const res = await getlist(this.listType, this.page);
    this.fetchListData(res);
  }
  fetchListData(res: any) {
    if (res.status === 1 || res.code === 500 || res.msg === '暂无数据') {
      this.finished = true;
    } else {
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
      this.finished = false;
    }
    this.loading = false;
  }
  // 进入详情页
  enterDetailPage(item: any) {
    this.$emit('enterDetailPage', item.id);
  }

  fetchSearch(e: any) {
    this.SearchData = e;
  }
  // 开始搜索
  startSearch() {
    if (this.SearchData) {
      searchData(this.listType, 1, this.SearchData).then((res: any) =>
        this.searchNewsData(res),
      );
    } else {
      this.getListData = [];
      this.page = 1;
      this.finished = false;
      setTimeout(() => {
        this.onLoad();
      }, 500);
    }
  }
  searchNewsData(res: any) {
    this.getListData = [...res.data];
    this.finished = true;
  }
  // 点击充值
  async handleClickTopUp() {
    const token = window.gettoken();
    // 判断是否在app内
    if (!window.udid) {
      (this.$refs.tipDownload as TipDownloadSy).tipFn();
    } else if (token && token !== 'null') {
      this.$router.push({
        name: 'CQYScoin-record',
      });
    } else {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
    }
  }

  // 接受详情页面点赞成功后修改赞数
  listenDetail() {
    EventBus.$on('AfterVote', (param: any) => {
      this.getListData.forEach((item: any) => {
        if (item.id === param.voteId) {
          item.votes = param.data;
        }
      });
      this.getListData.sort((a: any, b: any) => {
        return Number(b.votes as string) - Number(a.votes as string);
      });
    });
  }
}
